import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TRANSLATIONS_PROVIDER } from '../../translations.token';
import {
  VideoCaptureQuestionParams,
  VideoCaptureQuestionViewModel,
  VideoCaptureTranslations,
  VideoSrc
} from './video-capture.model';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export class VideoCapturePresenter {
  public readonly translationsProvider = inject(TRANSLATIONS_PROVIDER);
  private videoCaptureViewModel: VideoCaptureQuestionViewModel;

  private videoSrc: VideoSrc[];

  load(params: VideoCaptureQuestionParams): VideoCaptureQuestionViewModel {
    const value = params?.value ?? [];
    this.videoSrc = value?.map(video => {
      return {
        id: this.getId(video),
        src: video
      };
    });
    this.videoCaptureViewModel = {
      key: params.key,
      label: params.label,
      required: params.required ?? false,
      form: this.getForm(params),
      translations: this.getTranslations(),
      videoSrc: this.videoSrc
    };
    return this.videoCaptureViewModel;
  }

  private getTranslations(): VideoCaptureTranslations {
    return {
      required: this.translationsProvider.getTranslation('required')
    };
  }

  private getForm(params: VideoCaptureQuestionParams): FormGroup {
    const { key, value, required } = params;
    return new FormGroup({
      [key]: new FormControl(value, required ? [Validators.required] : [])
    });
  }

  public getId(video: string): string {
    const existingVideoIdx = this.videoSrc?.findIndex(v => v.src === video);
    if (existingVideoIdx > -1) {
      return this.videoSrc[existingVideoIdx].id;
    }
    return video.startsWith('data:') ? uuidv4() : video.split('?')[0].split('/').pop() ?? uuidv4();
  }
}
